<div
  *ngrxLet="{
    enableReferrals: enableReferralProgram$,
    isTrialSubscription: isTrialSubscription$,
  } as context">
  @if (context.enableReferrals && !context.isTrialSubscription) {
    @if (impactToken && isWidgetReady) {
      <div>
        <impact-embed widget="p/24474/w/referrerWidget"></impact-embed>
      </div>
    }
  }
  @if (!context.enableReferrals || context.isTrialSubscription) {
    <div class="text-center">
      <h2>Referral Program is not enabled</h2>
    </div>
  }
</div>
